import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { DataBagService } from 'src/app/common/data-bag.service';
import { InfoboxService } from 'src/app/common/infobox/infobox.service';
import { OrganizationService } from '../../organization.service';

export interface WorkersData {
	user: {
		email: string;
		password: string;
		first_name: string;
		last_name: string;
	};
	department: number;
	role: number;
}
@Component({
	selector: 'app-organization-workers-add',
	templateUrl: './organization-workers-add.component.html',
	styleUrls: ['./organization-workers-add.component.css'],
})
export class OrganizationWorkersAddComponent {
	organizationWorkersData: WorkersData = {
		user: {
			email: null,
			password: null,
			first_name: null,
			last_name: null,
		},
		department: null,
		role: null,
	};
	constructor(
		public service: OrganizationService,
		public infobox: InfoboxService,
		private readonly dialogRef: MatDialogRef<any>,
		private readonly bag: DataBagService,
	) {}

	generatePassword() {
		const length = 10;
		const charSet = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
		let returnedPassword = '';

		for (let i = 0, n = charSet.length; i < length; ++i) {
			returnedPassword += charSet.charAt(Math.floor(Math.random() * n));
		}

		return returnedPassword;
	}

	getDepartment(getDep) {
		return this.service.enterpriseData.departmentKinds.find((findDep) => findDep.id === getDep).name;
	}

	addOrganizationWorker() {
		if (
			this.organizationWorkersData.user.email === null ||
			this.organizationWorkersData.user.first_name === null ||
			this.organizationWorkersData.user.last_name === null ||
			this.organizationWorkersData.department === null
		) {
			this.infobox.error('Uzupełnij wszystkie dane!');
			return;
		}

		this.organizationWorkersData.user.password = this.generatePassword();

		this.bag.post('/organization/user/', this.organizationWorkersData, (result, error) => {
			if (error) {
				return;
			}
			this.service.enterpriseData.users.push(result);
			this.dialogRef.close(true);
		});
	}
}
